<template>
  <div>
    <ul class="nav nav-pills rwt-portfolio-filter filter-button-default liststyle mb--20" aria-label="Product categories">
      <li v-for="category in filters" :key="category" class="nav-item list-item">
        <button type="button" class="nav-link" :class="{ active: category === activeCategory }"
                :aria-pressed="category === activeCategory" @click="goto(category)">
          {{ category }}
        </button>
      </li>
    </ul>
    <p v-if="!visibleProducts.length" class="text-center" role="status">No products in this category.</p>
    <div class="row row--15">
      <div v-for="product in visibleProducts" :key="product.asin" :class="`${column} product`" data-aos="fade-up">
        <div class="rwt-card">
          <div class="inner">
            <div class="thumbnail">
              <figure class="card-image">
                <a :href="product.amazonUrl" target="_blank" rel="noopener noreferrer"><img v-if="product.albums.length" class="img-fluid" :src="product.albums[0].url" :alt="product.title"/></a>
              </figure>
              <a :href="product.amazonUrl" target="_blank" rel="noopener noreferrer" class="rwt-overlay"></a>
            </div>
            <div class="content">
              <h5 class="title mb--10"><a :href="product.amazonUrl" target="_blank" rel="noopener noreferrer">{{ product.title }}</a></h5>
              <span class="subtitle b2 text-capitalize">{{ categoryName(product.categoryId) }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import site from '@/data/site.json'

export default {
  name: 'Product',
  props: {
    products: { type: Array, required: true },
    column: { type: String, default: 'col-lg-6 col-md-6 col-sm-12 col-12 mt--30' }
  },
  computed: {
    filters() {
      return ['all', ...site.categories.map(category => category.name)]
    },
    // The route is the single source of truth for menus, back/forward navigation and direct links.
    activeCategory() {
      return this.$route.params.category || 'all'
    },
    visibleProducts() {
      if (this.activeCategory === 'all') return this.products
      const category = site.categories.find(item => item.name === this.activeCategory)
      return category ? this.products.filter(product => product.categoryId === category.id) : []
    }
  },
  watch: {
    activeCategory: {
      immediate: true,
      handler(category) {
        console.debug('[static-site] category-selected', { site: site.brand, category, count: this.visibleProducts.length })
      }
    }
  },
  methods: {
    categoryName(id) {
      return site.categories.find(category => category.id === id).name
    },
    goto(category) {
      if (category === this.activeCategory) return
      this.$router.replace({ name: 'Product', params: { category }, query: this.$route.query })
    }
  }
}
</script>
